import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Title", -1)
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)
const _hoisted_8 = {
  key: 0,
  class: "image field"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "image" }, "Image", -1)
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Image", -1)
const _hoisted_12 = { class: "p-inputgroup" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = {
  key: 2,
  class: "preview"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Preview:", -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "form-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.category)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.categoryId)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Edit Category"))
          : (_openBlock(), _createElementBlock("h1", _hoisted_3, "Add Category")),
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              id: "title",
              type: "text",
              modelValue: _ctx.category.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.category.title) = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Textarea, {
              id: "description",
              modelValue: _ctx.category.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.category.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          (!_ctx.customImageUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", null, [
                  _createVNode(_component_FileUpload, {
                    label: "hello",
                    id: "image",
                    mode: "basic",
                    accept: "image/*",
                    auto: "",
                    customUpload: true,
                    onUploader: _ctx.uploadImage
                  }, null, 8, ["onUploader"])
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_InputText, {
                      id: "title",
                      type: "text",
                      modelValue: _ctx.category.imageUrl,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.category.imageUrl) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Button, {
                    label: "Reload Preview",
                    onClick: _ctx.reloadPreview
                  }, null, 8, ["onClick"])
                ])
              ], 64)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.customImageUrl = !_ctx.customImageUrl), ["prevent"])),
              class: "p-button-link"
            }, _toDisplayString(_ctx.customImageUrl
							? 'Upload an image instead'
							: 'Enter a custom image URL instead'), 1)
          ]),
          (_ctx.previewUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("img", {
                  src: _ctx.previewUrl,
                  alt: "Image"
                }, null, 8, _hoisted_17)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Button, {
              label: _ctx.categoryId ? 'Save Category' : 'Add Category',
              type: "submit"
            }, null, 8, ["label"]),
            (_ctx.categoryId)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-danger",
                  onClick: _ctx.deleteCategory
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}